import { GA4DataLayer, GA4DataLayerFn } from "@packages/lib/utlils/helper-function";
import Link from "next/link";
import { GAConstants } from "../services/constants";

const BeenToUni = ({commonGAAttrs, commonGAAttrsOld}: any) => {
  const handleWriteReviewClick = () => {
    GA4DataLayer({
      ...commonGAAttrs,
      // event: "ga_events",
      // eventName: "ai_summarised_reviews",
      // data_label: "filter_click",
      // data_label2: "left_nav_cta",
      // data_label3: "been_to_uni_section",
      // data_label4: "write_review_cta_click",
      event: GAConstants.track_kpi,
      event_name: "write_a_review",
      click_text: "write_a_review",
    });
    GA4DataLayerFn({
      ...commonGAAttrsOld,
      event: GAConstants.review_events,
      eventName: "write_a_review",
      data_label: commonGAAttrsOld?.page_name,
    });
  };

    return (
        <div className="inline-flex flex-col  items-start gap-2 flex flex-col justify-start  bg-gray-50 rounded-lg outline outline-1 outline-offset-[-1px] outline-grey200 p-[16px]">
            <div className="h6 text-grey300 font-farro mb-[4px]">Been to uni?</div>

            <p className="self-stretch justify-start text-grey300 text-base font-normal font-inter mb-[11px]">Help other students make one of the biggest decisions</p>

            <Link href="/university-reviews/" className="btn btn-primary btn-large flex items-center" onClick={handleWriteReviewClick}>
                <span className="text-center justify-center text-white text-base font-semibold font-inter mr-[7px]">Write a review</span>
                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.03682 0.888672L14.222 6.07386M14.222 6.07386L9.03682 11.259M14.222 6.07386L0.888672 6.07386" stroke="white" stroke-width="1.77778" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </Link>
        </div >
    )
}

export default BeenToUni;